import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ContentList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 30px;
`;
